module.exports = __webpack_public_path__ + "static/media/unitedWayLogoShadow.44c1373d.png";